import { useStyleRegister } from '@ant-design/cssinjs';
import { useContext } from 'react';
import { ConfigContext } from '../../config-provider/context';
import { mergeToken, statisticToken, useToken } from '../index';
export default function genComponentStyleHook(component, styleFn, getDefaultToken) {
    return (prefixCls) => {
        const [theme, token, hashId] = useToken();
        const { getPrefixCls, iconPrefixCls } = useContext(ConfigContext);
        const rootPrefixCls = getPrefixCls();
        return [
            useStyleRegister({ theme, token, hashId, path: [component, prefixCls] }, () => {
                const { token: proxyToken, flush } = statisticToken(token);
                const defaultComponentToken = typeof getDefaultToken === 'function' ? getDefaultToken(proxyToken) : getDefaultToken;
                const overrideComponentToken = token[component];
                // Only merge token specified in interface
                const mergedComponentToken = Object.assign({}, defaultComponentToken);
                if (overrideComponentToken) {
                    Object.keys(mergedComponentToken).forEach(key => {
                        var _a;
                        mergedComponentToken[key] = (_a = overrideComponentToken[key]) !== null && _a !== void 0 ? _a : mergedComponentToken[key];
                    });
                }
                const mergedToken = mergeToken(proxyToken, {
                    componentCls: `.${prefixCls}`,
                    prefixCls,
                    iconCls: `.${iconPrefixCls}`,
                    antCls: `.${rootPrefixCls}`,
                }, mergedComponentToken);
                const styleInterpolation = styleFn(mergedToken, {
                    hashId,
                    prefixCls,
                    rootPrefixCls,
                    iconPrefixCls,
                });
                flush(component, mergedComponentToken);
                return styleInterpolation;
            }),
            hashId,
        ];
    };
}
